import { render, staticRenderFns } from "./ServicesList.vue?vue&type=template&id=18961f11&scoped=true&"
import script from "./ServicesList.vue?vue&type=script&lang=js&"
export * from "./ServicesList.vue?vue&type=script&lang=js&"
import style0 from "./ServicesList.vue?vue&type=style&index=0&id=18961f11&lang=scss&scoped=true&"
import style1 from "./ServicesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18961f11",
  null
  
)

export default component.exports